export default __webpack_public_path__ + "static/media/app_store_fr.fa603df2.svg";